<p-panel [(ngModel)]="cliente">
  <p-header class="ui-panel-title">
    <label il8n="@@labelText74">Editar Dados do Usuário</label>
    <p-messages [(value)]="messageDados"></p-messages>
  </p-header>
  <h3 class="first" i18n="@@labelH3Text1">Dados Cadastrais</h3>

  <label i18n="@@labelText1">Código</label>
  <div class="ui-g ui-fluid">
    <div class="ui-g-12 ui-md-4" style="float: left">
        <div class="ui-inputgroup">
          <input name="codigo" type="text" pInputText [disabled]="true" value="{{cliente.codigo}}">
        </div>
    </div>
  </div>
  <label i18n="@@labelText2">Nome / Razão</label>
  <div class="ui-g ui-fluid">
    <div class="ui-g-12 ui-md-4">
        <div class="ui-inputgroup">
          <input name="nomeTitular" type="text" required="true" pInputText value="{{cliente.nomeTitular}}" [(ngModel)]="clienteParam.nomeTitular">
        </div>
    </div>
  </div>
  <label i18n="@@labelText3">RG</label>
  <div class="ui-g ui-fluid">
    <div class="ui-g-12 ui-md-4">
        <div class="ui-inputgroup">
          <input name="rg" type="text" pInputText value="{{cliente.rg}}" [(ngModel)]="clienteParam.rg">
        </div>
    </div>
  </div>
  <label i18n="@@labelText4">CPF / CNPJ</label>
  <div class="ui-g ui-fluid">
     <div class="ui-g-12 ui-md-4">
       <div class="ui-inputgroup">
         <input [mask]="maskCpfCnpj" name="cpf" type="text" [disabled]="true" pInputText value="{{cliente.cpf}}" [(ngModel)]="clienteParam.cpf">
       </div>
    </div>
  </div>

  <h3 i18n="@@labelH3Text2">Contatos</h3>

  <label i18n="@@labelText5">Email</label>
  <div class="ui-g ui-fluid">
    <div class="ui-g-12 ui-md-4">
      <div class="ui-inputgroup">
        <input name="email" type="email" [email]="true" required="true" pInputText value="{{cliente.email}}" [(ngModel)]="clienteParam.email">
      </div>
    </div>
  </div>
  <label i18n="@@labelText6">Telefone</label>
  <div class="ui-g ui-fluid">
    <div class="ui-g-12 ui-md-4">
      <div class="ui-inputgroup">
        <input name="foneResidencia" type="text" maxlength="12" pInputText value="{{cliente.foneResidencia}}" [(ngModel)]="clienteParam.foneResidencia">
      </div>
    </div>
  </div>
  <label i18n="@@labelText7">Celular</label>
  <div class="ui-g ui-fluid">
    <div class="ui-g-12 ui-md-4">
      <div class="ui-inputgroup">
          <input name="celular" type="text" maxlength="12" pInputText value="{{cliente.celular}}" [(ngModel)]="clienteParam.celular">
      </div>
    </div>
  </div>
  <p-footer>
    <div style="text-align: right">
      <button pButton type="button" label="Editar Dados" i18n="@@labelText76" style="margin-right: 10px" (click)="editar()"></button>
      <button pButton type="button" label="Cancelar" i18n="@@labelText79" [routerLink]="['/listaOrdemServico']"></button>
    </div>
  </p-footer>
</p-panel>

<p-panel>
  <p-header class="ui-panel-title">
    <label i18n="@@labelText80">Editar Senha</label>
  </p-header>
  <p-messages [(value)]="message"></p-messages>
  <label i18n="@@labelText81">Senha Antiga</label>
  <div class="ui-g ui-fluid">
    <div class="ui-g-12 ui-md-3">
      <div class="ui-inputgroup">
        <input id="oldPass" type="password" pInputText name="senha" />
      </div>
    </div>
  </div>

  <label i18n="@@labelText82">Senha Nova</label>
  <div class="ui-g ui-fluid">
    <div class="ui-g-12 ui-md-3">
      <div class="ui-inputgroup">
        <input id="newPass" type="password" feedback="true" name="senha" pPassword/>
      </div>
    </div>
    <div class="ui-g-12 ui-md-3">
      <div class="ui-inputgroup">
        <input id="newPassConf" type="password" name="senha" pInputText />
      </div>
    </div>
  </div>
  <p-footer>
    <div style="text-align: right">
      <button pButton type="button" i18n="@@labelText80" label="Editar Senha" style="margin-right: 10px" (click)="trocarSenha()"></button>
      <button pButton type="button" i18n="@@labelText79" label="Cancelar" [routerLink]="['/listaOrdemServico']"></button>
    </div>
  </p-footer>
</p-panel>
<br>
